import { comparePeriods } from '../../utils/DateUtils'

/**
 * Strategy: which periods a picker is allowed to reach.
 *
 * Pickers ask the strategy rather than testing min/max themselves, so adding a
 * new kind of restriction means adding a subclass, not another conditional.
 */
class PeriodBounds {
    /** Whether this exact period may be selected. */
    includes(_period) {
        throw new Error("You must implement the includes method");
    }

    /** Whether any month of this year may be selected. */
    reachesYear(_year) {
        throw new Error("You must implement the reachesYear method");
    }

    /** The year to show when nothing is selected yet. */
    defaultYear(_currentYear) {
        throw new Error("You must implement the defaultYear method");
    }
}

/** Any period is reachable. The default for date columns and free navigation. */
class UnboundedPeriods extends PeriodBounds {
    includes() {
        return true;
    }

    reachesYear() {
        return true;
    }

    defaultYear(currentYear) {
        return currentYear;
    }
}

/** Restricted to an inclusive period range, e.g. the company's published periods. */
class PeriodRange extends PeriodBounds {
    constructor(min, max) {
        super();
        this.min = min;
        this.max = max;
    }

    includes(period) {
        return comparePeriods(period, this.min) >= 0 && comparePeriods(period, this.max) <= 0;
    }

    reachesYear(year) {
        return year >= this.min.year && year <= this.max.year;
    }

    defaultYear() {
        return this.max.year;
    }
}

export const UNBOUNDED_PERIODS = new UnboundedPeriods()

export { PeriodBounds, UnboundedPeriods, PeriodRange }
